import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import routes from '../routes';
import Header from './Header'; 
import { Suspense, lazy, useEffect, useRef } from 'react';  
import SuspenseContent from "./SuspenseContent";
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

const Page404 = lazy(() => import('../pages/protected/404'));

function PageContent() {
    const mainContentRef = useRef(null);
    const { pageTitle } = useSelector(state => state.header);
    useEffect(() => {
        if (mainContentRef.current) {
            mainContentRef.current.scroll({
                top: 0,
                behavior: "smooth"
            });
        }
    }, [pageTitle]);

    return (
        <div className="drawer-content flex flex-col">
            
            {/* Add padding-top equal to the header's height to avoid content overlap */}
            <main
                ref={mainContentRef}
                style={{ paddingTop: "64px" }} // Adjust this value based on the actual height of the Header
            >
                <Suspense fallback={<SuspenseContent />}>
                    <Routes>
                        {routes.map((route, key) => (
                            <Route
                                key={key}
                                exact={true}
                                path={route.path}
                                element={<route.component />}
                            />
                        ))}

                        {/* Redirecting unknown URL to 404 page */}
                        <Route path="*" element={<Page404 />} />
                    </Routes>
                </Suspense>
                {/* Spacer for bottom padding */}
                <div className="h-16"></div>
            </main>
        </div>
    );
}

export default PageContent;
